module.exports = __webpack_public_path__ + "img/stickers-jugement-divorce.22aa74eb.jpg";